import { z } from 'zod';

export type FrameProfilingEventType = 'click' | 'navigation-timing';

export const ClickedProfilingEventSchema = z
	.object({
		event: z.literal('click'),
	})
	.strip();

export const NavigationTimingProfilingEventSchema = z
	.object({
		event: z.literal('navigation-timing'),
		transferSize: z.number().nonnegative().finite(),
		duration: z.number().nonnegative().finite(),
	})
	.strict();

export const AppFrameProfilingEventSchema = z.discriminatedUnion('event', [
	ClickedProfilingEventSchema,
	NavigationTimingProfilingEventSchema,
]);
